export class DownloadHelper {
    static download(url, filename) {
        return new Promise((resolve, reject) => {
            const initiateDownload = (blob) => {
                try {
                    const downloadUrl = URL.createObjectURL(blob);
                    const downloadElement = document.createElement('a');
                    downloadElement.href = downloadUrl;
                    downloadElement.download = filename || '';
                    downloadElement.style.display = 'none';
                    document.body.appendChild(downloadElement);
                    downloadElement.click();
                    document.body.removeChild(downloadElement);

                    // Revoke the object URL to free up memory
                    setTimeout(() => URL.revokeObjectURL(downloadUrl), 100);

                    resolve({ success: true, message: 'Download completed successfully' });
                } catch (error) {
                    reject(error);
                }
            };

            const fetchAndDownload = () => {
                return fetch(url)
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }
                        return response.blob();
                    })
                    .then((blob) => initiateDownload(blob))
                    .catch((error) => reject(error));
            };

            const isIOS = /iPad|iPhone|iPod/.test(navigator.platform);

            if (isIOS) {
                fetchAndDownload();
            } else {
                // setTimeout is required as a workaround for this issue:
                //
                // "Fetch requests inside onClick abort when downloading a file in Firefox"
                // https://stackoverflow.com/questions/57542425/fetch-requests-inside-onclick-abort-when-downloading-a-file-in-firefox
                //
                // This allows us to record device events and download files simultaneously.
                // This issue affects Firefox and Safari browsers.
                setTimeout(() => {
                    try {
                        fetchAndDownload();
                    } catch (error) {
                        reject(error);
                    }
                }, 10);
            }
        });
    }

    /**
     * Generic download handler with persistent toast
     * @param {string} url - Download URL
     * @param {string} filename - Filename for download
     * @param {Object} toastService - Toast service instance
     * @param {function} onSuccess - Success callback
     * @param {function} onError - Error callback (optional)
     * @param {string} startMessage - Toast message when download starts
     * @param {Object} i18next - i18next instance for translations
     */
    static async downloadWithToast(url, filename, toastService, onSuccess, onError = null, startMessage = null, i18next = null) {
        const defaultStartMessage =
            startMessage || (i18next ? i18next.t('download-as-one-started-toast') : null) || 'Preparing download...';

        toastService.showPersistentToast(defaultStartMessage, 'info');

        try {
            return this.download(url, filename)
                .then(() => {
                    if (onSuccess) onSuccess();
                    toastService.hidePersistentToast();
                    const successMessage = (i18next ? i18next.t('download-complete') : null) || 'Download ready!';
                    toastService.showToast(successMessage, 'success');
                })
                .catch((error) => {
                    if (onError) onError(error);
                    toastService.hidePersistentToast();
                    const errorMessage = (i18next ? i18next.t('download-error') : null) || 'Download failed';
                    toastService.showToast(errorMessage, 'error');
                    throw error;
                });
        } catch (error) {
            toastService.hidePersistentToast();
            throw error;
        }
    }
}
